import { BAR_CHART_CONFIG, BOX_PLOT_CHART_CONFIG, CMA_DOUGHNUT_CHART_CONFIG, DOUGHNUT_CHART_CONFIG, DOUGHNUT_CHART_PDF_CONFIG, INSIGHT_MULTI_COLUMN_CHART_CONFIG, INSIGHT_MULTI_COLUMN_CHART_CONFIG_PDF, IQ_DOUGHNUT_CHART_CONFIG, PROJECTED_GROWTH_CONFIG, PROJECTED_RETURN_CONFIG, STACKED_GROUPED_BAR_CHART_CONFIG, STACKED_GROUPED_BAR_TOP_CHART_CONFIG, STACKED_GROUPED_COLUMN_CHART_CONFIG } from '../configs';
import { SPLIT_COLUMN_CHART_CONFIG } from '../configs/column/split-column-chart.config';
import { IHighChartsAttributesModel } from '../models/high-charts-attributes.interface';
import { BarChartWorker, BoxPlotChartWorker, IChartWorker, InsightEmergingMarketChartWorker, PieChartWorker, ProjectedChartWorker, SplitColumnChartWorker, StackedGroupedBarWorker, StackedGroupedColumnWorker } from '../workers';
import { CompositeStackedBarChartWorker } from '../workers/bar/composite-stacked-bar-chart.worker';
import { PortfolioEditorPieChartWorker } from '../workers/pie/portfolio-editor-pie-chart.worker';
import { PortfolioMonitorPieChartWorker } from '../workers/pie/portfolio-monitor-pie-chart.worker';

/**
 * @description ChartDispatcher: responsible for dispatching what type of chart is created.
 * @param {any} config JSON object representing the chart configuration.
 * @param {HighChartsAttributesModel} highChartsAttributes an object containing properties used to augment the chart configuration.
 */
export class ChartDispatcher {
	constructor(private highChartsAttributes: IHighChartsAttributesModel) { }
	public createWorker(): IChartWorker {
		switch (this.highChartsAttributes.chartType) {
			case 'bar':
				return new BarChartWorker(BAR_CHART_CONFIG, this.highChartsAttributes);
			case 'box':
				return new BoxPlotChartWorker(BOX_PLOT_CHART_CONFIG, this.highChartsAttributes);
			case 'doughnut':
				return new PieChartWorker(DOUGHNUT_CHART_CONFIG, this.highChartsAttributes);
			case 'doughnut-pdf':
				return new PieChartWorker(DOUGHNUT_CHART_PDF_CONFIG, this.highChartsAttributes);
			case 'insight-multi-column':
				return new InsightEmergingMarketChartWorker(INSIGHT_MULTI_COLUMN_CHART_CONFIG, this.highChartsAttributes);
			case 'insight-multi-column-pdf':
				return new InsightEmergingMarketChartWorker(INSIGHT_MULTI_COLUMN_CHART_CONFIG_PDF, this.highChartsAttributes);
			case 'split-column':
				return new SplitColumnChartWorker(SPLIT_COLUMN_CHART_CONFIG, this.highChartsAttributes);
			case 'stacked-group-column':
				return new StackedGroupedColumnWorker(STACKED_GROUPED_COLUMN_CHART_CONFIG, this.highChartsAttributes);
			case 'stacked-group-bar':
				return new StackedGroupedBarWorker(STACKED_GROUPED_BAR_CHART_CONFIG, this.highChartsAttributes);
			case 'stacked-group-top-bar':
				return new StackedGroupedBarWorker(STACKED_GROUPED_BAR_TOP_CHART_CONFIG, this.highChartsAttributes);
			case 'composite-stacked-bar':
				return new CompositeStackedBarChartWorker(STACKED_GROUPED_BAR_CHART_CONFIG, this.highChartsAttributes);
			case 'pe-doughnut':
				return new PortfolioEditorPieChartWorker(DOUGHNUT_CHART_CONFIG, this.highChartsAttributes);
			case 'projected-growth':
				return new ProjectedChartWorker(PROJECTED_GROWTH_CONFIG, this.highChartsAttributes);
			case 'projected-return':
				return new ProjectedChartWorker(PROJECTED_RETURN_CONFIG, this.highChartsAttributes);
			case 'cma-doughnut':
				return new PieChartWorker(CMA_DOUGHNUT_CHART_CONFIG, this.highChartsAttributes);
			case 'iq-doughnut':
				return new PieChartWorker(IQ_DOUGHNUT_CHART_CONFIG(this.highChartsAttributes.tabData), this.highChartsAttributes);
			case 'pm-doughnut':
				return new PortfolioMonitorPieChartWorker(DOUGHNUT_CHART_CONFIG, this.highChartsAttributes);
		}
	}
}
